module.exports = __webpack_public_path__ + "img/org-moh.7ca4628c.jpg";